@if (grid$ | async; as grid) {
    <ms-grid-list class="grid-list" [model]="grid" [hideFavourites]="true" [tracking]="tracking" />
}
